import { WebApi } from 'common/http';

import type { ParsedMarkdownResponse } from 'types';

export async function parseMarkdown(markdown: string) {
  const { data: response } = await WebApi.post<ParsedMarkdownResponse>('/parse-markdown', { markdown });
  const { data } = response || {};
  return data;
}
